import React from 'react'

export default function ResultData(props) {
  return (
    <div className={props.className}>
        {props.children}
    </div>
  )
}
